import React, { useState, useEffect } from "react";
import api from "../../core/api/config";

const statusConfig = {
  ABERTO: { id: 1, class: "status-aberto", label: "Abertos" },
  EM_ATENDIMENTO: { id: 2, class: "status-andamento", label: "Em atendimento" },
  RESOLVIDO: { id: 3, class: "status-resolvido", label: "Resolvidos" },
  FECHADO: { id: 4, class: "status-fechado", label: "Fechados" },
  CANCELADO: { id: 5, class: "status-cancelado", label: "Cancelados" },
  MELHORIA: { id: 6, class: "status-melhoria", label: "Melhoria" },
  AGUARDANDO: { id: 7, class: "status-aguardando", label: "Aguardando" },
};

const Chamados = () => {
  const [chamados, setChamados] = useState([]);
  const [selectedChamado, setSelectedChamado] = useState(null);
  const [search, setSearch] = useState("");
  const [filtroStatus, setFiltroStatus] = useState(null);

  const getChamados = async () => {
    try {
      const response = await api.get("/api/tracking/chamados");

      const dados =
        typeof response.data === "string"
          ? JSON.parse(response.data)
          : response.data;

      const formatados = dados
        .sort((a, b) => new Date(b.dataAbertura) - new Date(a.dataAbertura))
        .map((item) => ({
          id: item.id,
          numeroChamado: item.numeroChamado,
          assunto: item.assunto,
          mensagem: item.mensagem,
          dataAbertura: new Date(item.dataAbertura).toLocaleString("pt-BR"),
          email: item.email,
          nomeUsuario: item.nomeUsuario,
          nomeStatus: item.nomeStatus,
          nomeArquivo: item.nomeArquivo
            ? item.nomeArquivo.split("/").pop()
            : null,
        }));

      setChamados(formatados);
      if (formatados.length > 0) setSelectedChamado(formatados[0]);
    } catch (error) {
      console.error(error);
    }
  };

  useEffect(() => {
    getChamados();
  }, []);

  const statusResumo = chamados.reduce((acc, chamado) => {
    acc[chamado.nomeStatus] = (acc[chamado.nomeStatus] || 0) + 1;
    return acc;
  }, {});

  const alterarStatus = async (novoStatusId) => {
    try {
      await api.patch(
        `/api/tracking/chamados/${selectedChamado.id}/status?statusId=${novoStatusId}`,
      );

      const novoNomeStatus = Object.keys(statusConfig).find(
        (key) => statusConfig[key].id === Number(novoStatusId),
      );

      const listaAtualizada = chamados.map((c) =>
        c.id === selectedChamado.id ? { ...c, nomeStatus: novoNomeStatus } : c,
      );

      setChamados(listaAtualizada);
      setSelectedChamado({
        ...selectedChamado,
        nomeStatus: novoNomeStatus,
      });
    } catch {
      alert("Erro ao atualizar status.");
    }
  };

  const visualizarArquivo = async (nomeArquivo) => {
    try {
      const response = await api.get(
        `/api/tracking/chamados/arquivo/${nomeArquivo}`,
        { responseType: "blob" },
      );

      const url = window.URL.createObjectURL(response.data);
      const win = window.open("", "_blank");

      if (win) {
        win.document.write(`
          <html>
            <body style="margin:0">
              <iframe src="${url}" width="100%" height="100%" style="border:none;"></iframe>
            </body>
          </html>
        `);
      }
    } catch {
      alert("Erro ao abrir anexo.");
    }
  };

  // FILTRO COMBINADO (busca + status)
  const chamadosFiltrados = chamados.filter((c) => {
    const matchBusca =
      c.nomeUsuario?.toLowerCase().includes(search.toLowerCase()) ||
      c.assunto?.toLowerCase().includes(search.toLowerCase());

    const matchStatus = filtroStatus ? c.nomeStatus === filtroStatus : true;

    return matchBusca && matchStatus;
  });

  return (
    <div className="page-wrapper">
      <div className="content">
        <div className="page-header">
          <div className="page-title">
            <h4>Central de Chamados</h4>
            <h6>Gestão de solicitações</h6>
          </div>
        </div>

        <div className="card shadow-sm">
          <div className="card-body p-0">
            <div className="row g-0">
              {/* LISTA */}
              <div className="col-md-4 border-end lista-chamados">
                {/* RESUMO CLICÁVEL */}
                <div className="resumo-status">
                  {Object.keys(statusConfig).map((key) => (
                    <span
                      key={key}
                      className={`resumo-item ${statusConfig[key].class} ${
                        filtroStatus === key ? "ativo" : ""
                      }`}
                      onClick={() =>
                        setFiltroStatus(filtroStatus === key ? null : key)
                      }
                    >
                      {statusResumo[key] || 0} {statusConfig[key].label}
                    </span>
                  ))}
                </div>

                {/* BUSCA */}
                <div className="p-3 border-bottom">
                  <input
                    type="text"
                    className="form-control form-control-sm"
                    placeholder="Buscar chamado..."
                    value={search}
                    onChange={(e) => setSearch(e.target.value)}
                  />
                </div>

                {/* LISTA */}
                <div className="lista-scroll">
                  {chamadosFiltrados.map((item) => (
                    <div
                      key={item.id}
                      className={`item-chamado ${
                        selectedChamado?.id === item.id ? "item-ativo" : ""
                      }`}
                      onClick={() => setSelectedChamado(item)}
                    >
                      <div className="item-header">
                        <strong>{item.nomeUsuario}</strong>
                        <small>{item.dataAbertura}</small>
                      </div>

                      <div className="item-assunto">
                        #{item.numeroChamado} — {item.assunto}
                      </div>

                      <span
                        className={`status-badge ${statusConfig[item.nomeStatus]?.class}`}
                      >
                        {item.nomeStatus}
                      </span>
                    </div>
                  ))}
                </div>
              </div>

              {/* DETALHE permanece igual */}
              <div className="col-md-8 detalhe-chamado">
                {selectedChamado && (
                  <>
                    <div className="detalhe-header">
                      <h5>
                        #{selectedChamado.numeroChamado} —{" "}
                        {selectedChamado.assunto}
                      </h5>

                      <div className="detalhe-meta">
                        De: <strong>{selectedChamado.nomeUsuario}</strong> &lt;
                        {selectedChamado.email}&gt;
                        <br />
                        Enviado: {selectedChamado.dataAbertura}
                      </div>

                      <div className="mt-3">
                        <select
                          className="form-select form-select-sm status-select"
                          value={statusConfig[selectedChamado.nomeStatus]?.id}
                          onChange={(e) => alterarStatus(e.target.value)}
                        >
                          {Object.keys(statusConfig).map((key) => (
                            <option key={key} value={statusConfig[key].id}>
                              {key}
                            </option>
                          ))}
                        </select>
                      </div>
                    </div>

                    <div className="detalhe-body">
                      {selectedChamado.nomeArquivo && (
                        <button
                          className="btn-anexo"
                          onClick={() =>
                            visualizarArquivo(selectedChamado.nomeArquivo)
                          }
                        >
                          <i
                            data-feather="paperclip"
                            className="feather-paperclip"
                          />
                          <span className="ms-2">
                            {selectedChamado.nomeArquivo}
                          </span>
                        </button>
                      )}
                      <p style={{ whiteSpace: "pre-line" }}>
                        {selectedChamado.mensagem}
                      </p>
                    </div>
                    <div className="detalhe-footer">
                      <textarea
                        className="form-control"
                        rows="5"
                        placeholder="Digite sua resposta..."
                      />
                      <button className="btn btn-primary btn-sm mt-2 ms-1 float-end">
                        <i data-feather="enviar" className="feather-send" />
                        <span className="ms-2">Enviar</span>
                      </button>
                      <button className="btn btn-outline-primary btn-sm mt-2 float-end">
                        <i
                          data-feather="paperclip"
                          className="feather-paperclip"
                        />
                      </button>
                    </div>
                  </>
                )}
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Chamados;
